<template>
  <div class="bind-box">
    <el-dialog :visible="$store.state.showBindBox == 0 ? false : true" width="30%" :before-close="_handleClose">
      <el-dialog width="30%" :visible.sync="innerVisible" append-to-body>
        <span slot="title">
          {{ $store.state.showBindBox == 1 ? $t('banck.bindexist') : $store.state.showBindBox == 2 ? $t('banck.bindexistd') : '' }}
        </span>
        <el-form :model="accountData" :rules="accountRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('banck.acc')" prop="account">
            <el-input v-model="accountData.account" :placeholder="$t('banck.entyacc')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('banck.password')" prop="password">
            <el-input v-model="accountData.password" :placeholder="$t('login.inputpwd')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_submitForm('ruleForm')" v-loading="bindLoading">{{ $t('banck.bindnow') }}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog width="40%" :visible.sync="innerVisible2" append-to-body>
        <span slot="title">
          {{ $store.state.showBindBox == 1 ? $t('home.araccount') : $store.state.showBindBox == 2 ? $t('banck.actdemoacc') : '' }}
        </span>
        <el-row :gutter="40">
          <el-col :span="12">
            <div class="real_account is-active">
              <span class="icon_acc"><img src="@/assets/image/real_icon.png"/></span>
              <span class="icon_text">{{ $t('home.racc') }}</span>
            </div>
            <p>
              {{ $t('home.perfected') }}
            </p>
          </el-col>
          <el-col :span="12">
            <div class="real_account is-active">
              <span class="icon_acc"><img src="@/assets/image/demo_icon.png"/></span>
              <span class="icon_text">{{ $t('home.dacc') }}</span>
            </div>
            <p>
              {{ $t('banck.virtra') }}
            </p>
          </el-col>
        </el-row>
        <el-row class="margin-top-set" v-if="$store.state.showBindBox == 1">
          <el-col :span="18" :offset="3">
            <el-form :model="accountData2" :rules="accountRules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
              <el-form-item :label="$t('banck.Realname')" prop="name">
                <el-input v-model="accountData2.name" :placeholder="$t('banck.entyourrn')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('basic.idnmu')" prop="credentialsNum">
                <el-row>
                  <el-col :span="7">
                    <el-select v-model="accountData2.issueCountry">
                      <el-option :label="$t('banck.China')" value="1"></el-option>
                      <el-option :label="$t('banck.chihk')" value="2"></el-option>
                      <el-option :label="$t('banck.chimac')" value="3"></el-option>
                      <el-option :label="$t('banck.chitw')" value="4"></el-option>
                      <el-option :label="$t('banck.othcoun')" value="5"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="16" :offset="1">
                    <el-input v-model="accountData2.credentialsNum" :placeholder="$t('basic.entidnum')"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('banck.setpassword')" prop="pwd">
                <el-input v-model="accountData2.pwd" :placeholder="$t('login.inputpwd')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('banck.promnum')" prop="promotionNumber">
                <el-input v-model="accountData2.promotionNumber" :placeholder="$t('banck.entpronum')"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_submitForm2('ruleForm2')" v-loading="bindLoading2">{{ $t('banck.bindnow') }}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row class="margin-top-set" v-if="$store.state.showBindBox == 2">
          <el-col :span="18" :offset="3">
            <el-form :model="accountData3" :rules="accountRules3" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
              <el-form-item :label="$t('basic.name')">
                <el-input :value="$store.state.userInfo.jfUser.name" disabled :placeholder="$t('basic.name')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('banck.mobilephone')">
                <el-input :value="$store.state.userInfo.jfUser.mobile" disabled :placeholder="$t('banck.mobilephone')"></el-input>
              </el-form-item>
              <!-- <el-form-item label="邮箱">
                <el-input :value="$store.state.userInfo.jfUser.email" disabled placeholder="邮箱"></el-input>
              </el-form-item> -->
              <el-form-item :label="$t('banck.setpassword')" prop="pwd">
                <el-input v-model="accountData3.pwd" :placeholder="$t('login.inputpwd')"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_submitForm3('ruleForm3')" v-loading="bindLoading3">{{ $t('banck.bindnow') }}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-dialog>
      <el-row>
        <el-col :span="18" :offset="3">
          <el-button class="btn-width" type="primary" @click="_bindAccount">{{
            $store.state.showBindBox == 1 ? $t('banck.bindexist') : $store.state.showBindBox == 2 ? $t('banck.bindexistd') : ''
          }}</el-button>
        </el-col>
        <el-col :span="18" :offset="3">
          <el-button class="btn-width" type="primary" plain @click="_activationAccount">{{
            $store.state.showBindBox == 1 ? $t('banck.noacctoopen') : $store.state.showBindBox == 2 ? $t('banck.nodemoacc') : ''
          }}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { bindAccount } from '@/api'
import { base64 } from '@/utils'
export default {
  data() {
    let checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('banck.notblank')))
      } else if (!/(^([a-zA-Z]+)(\s*[a-zA-Z])+$)|(^[\u4e00-\u9fa5]{2,20}$)/.test(value)) {
        callback(new Error(this.$t('banck.incfor')))
      } else {
        callback()
      }
    }
    let checkCardNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('banck.idnumnotblank')))
      } else if (this.accountData2.issueCountry == '1') {
        if (
          !/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(
            value
          )
        ) {
          callback(new Error(this.$t('banck.entidcorr!')))
        } else if (!this.isValida()) {
          callback(new Error(this.$t('banck.idbeenreg')))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    let checkPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('banck.pasnotempty')))
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,30}$/.test(value)) {
        // callback(new Error(this.$t('login.rulepass')))
      } else {
        callback()
      }
    }
    return {
      innerVisible: false,
      innerVisible2: false,
      accountData: {
        account: '',
        password: '',
      },
      accountRules: {
        account: [
          {
            required: true,
            message: this.$t('banck.entyacc'),
            trigger: 'blur',
          },
          {
            min: 6,
            max: 20,
            message: this.$t('banck.invformat'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('banck.pasnotempty'),
            trigger: 'blur',
          },
          { min: 6, max: 20, message: this.$t('banck.pass6'), trigger: 'blur' },
        ],
      },
      accountData2: {
        name: '',
        credentialsNum: '',
        issueCountry: '1',
        // birthday: '',
        promotionNumber: '',
        pwd: '',
        fromType: 1,
      },
      accountRules2: {
        name: [{ validator: checkName, trigger: 'blur' }],
        credentialsNum: [{ validator: checkCardNumber, trigger: 'blur' }],
        pwd: [{ validator: checkPwd, trigger: 'blur' }],
      },
      accountData3: {
        pwd: '',
        fromType: 1,
      },
      accountRules3: {
        pwd: [
          {
            required: true,
            message: this.$t('banck.pasnotempty'),
            trigger: 'blur',
          },
          { min: 6, message: this.$t('banck.pass6'), trigger: 'blur' },
        ],
      },
      bindLoading: false,
      bindLoading2: false,
      bindLoading3: false,
    }
  },
  methods: {
    isValida() {
      let params = {
        ident: this.accountData2.credentialsNum,
      }
      let res = this.validateData(params)
      return res
    },
    //验证数据是否重复
    validateData(params) {
      let isVal = true
      bindAccount.realUserData(params).done(res => {
        if (!res.IsSuccess) {
          isVal = false
        }
      })
      return isVal
    },
    _handleClose() {
      this.$store.commit('setBindBoxStatue', 0)
    },
    // 绑定账户
    _bindAccount() {
      if (this.$store.state.showBindBox == 1 || this.$store.state.showBindBox == 2) {
        this.innerVisible = true
      }
    },
    // 激活账户
    _activationAccount() {
      if (this.$store.state.showBindBox == 1 || this.$store.state.showBindBox == 2) {
        this.innerVisible2 = true
      }
    },
    // 绑定
    _submitForm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.bindLoading = true
          let params = {
            account: this.accountData.account,
            password: this.accountData.password,
            usertype: 1,
          }
          if (this.$store.state.showBindBox == 1) {
            bindAccount.realAccount(params).then(res => {
              this.bindLoading = false
              if (res.IsSuccess) {
                this.innerVisible = false
                this.$store.commit('setBindBoxStatue', 0)
                this.$store.commit('setAccountType', 2)
                this.$message.success(res.Data)
                this.$emit('changeAcc', 1)
              }
            })
          } else if (this.$store.state.showBindBox == 2) {
            bindAccount.simulatorAccount(params).then(res => {
              this.bindLoading = false
              if (res.IsSuccess) {
                this.innerVisible = false
                this.$store.commit('setBindBoxStatue', 0)
                this.$store.commit('setAccountType', 2)
                this.$message.success(res.Data)
                this.$emit('changeAcc', 0)
              }
            })
          }
        } else {
          this.bindLoading = false
          return false
        }
      })
    },
    _submitForm2(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.bindLoading2 = true
          let params = {
            name: this.accountData2.name,
            credentialsType: 1,
            credentialsNum: this.accountData2.credentialsNum,
            promotionNumber: this.accountData2.promotionNumber,
            pwd: this.accountData2.pwd,
            fromType: 1,
          }

          bindAccount.realAccountAc(params).then(res => {
            this.bindLoading2 = false
            if (res.IsSuccess) {
              this.innerVisible2 = false
              this.$store.commit('setBindBoxStatue', 0)
              this.$store.commit('setAccountType', 2)
              this.$alert(this.$t('banck.youaccis') + res.Data, this.$t('banck.activation'), {
                confirmButtonText: this.$t('bank.Confirm'),
                callback: action => {
                  this.$emit('changeAcc', 1)
                },
              })
            }
          })
        } else {
          this.bindLoading3 = false
          return false
        }
      })
    },
    _submitForm3(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.bindLoading3 = true
          let params = {
            pwd: this.accountData3.pwd,
            fromType: 1,
          }
          bindAccount.simulatorAccountAc(params).then(res => {
            this.bindLoading3 = false
            if (res.IsSuccess) {
              this.innerVisible2 = false
              this.$store.commit('setBindBoxStatue', 0)
              this.$store.commit('setAccountType', 2)
              this.$alert(this.$t('banck.demoacc') + res.Data, this.$t('banck.activation'), {
                confirmButtonText: this.$t('bank.Confirm'),
                callback: action => {
                  this.$emit('changeAcc', 0)
                },
              })
            }
          })
        } else {
          this.bindLoading3 = false
          return false
        }
      })
    },
  },
}
</script>

<style>
.margin-top-set {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/bindBox.vue